import Layout from '@/views/layout/Layout'

// const SGMSolution = [
//   {
//     path: "/SGMSolution",
//     component: Layout,
//     children: [
//         {
//         path: "",  // 空路径
//         component: () => import("@/views/SGMSolution/index"),
//         name: "SGMSolution",
//         meta: { noCache: true }
//         }
//     ],
//   },
// ];

const SGMSolution = [
  {
    path: "/SGMSolution",
    component: Layout,
    redirect: "sgm", // 添加重定向
    children: [
      {
        path: "sgm",  // 改為子路由
        component: () => import("@/views/SGMSolution/index"),
        name: "SGMSolution",  // 保持原名稱
        meta: { noCache: true }
      }
    ],
  },
];

export default SGMSolution